var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 393,
    viewBox: "0 0 744 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M734.21 51.2808L393.986 382.929C388.01 388.754 379.995 392.014 371.65 392.014C363.305 392.014 355.29 388.754 349.314 382.929L8.96184 51.2808C6.17503 48.5675 3.96007 45.3234 2.44768 41.7399C0.935287 38.1565 0.156112 34.3064 0.156112 30.4169C0.156112 26.5273 0.935287 22.6772 2.44768 19.0938C3.96007 15.5103 6.17503 12.2662 8.96184 9.55286C14.6766 3.97016 22.3488 0.844667 30.3379 0.844666C38.3269 0.844666 45.9991 3.97015 51.7139 9.55286L371.65 321.425L691.522 9.55283C697.234 3.98929 704.892 0.875887 712.866 0.875886C720.839 0.875886 728.498 3.98929 734.21 9.55283C736.997 12.2662 739.212 15.5103 740.724 19.0937C742.236 22.6772 743.016 26.5273 743.016 30.4168C743.016 34.3064 742.236 38.1565 740.724 41.7399C739.212 45.3233 736.997 48.5674 734.21 51.2808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.9c72e3eb33d6f358d98a28ee643ef84d.svg";
export { ForwardRef as ReactComponent };